<span class="main-title">{{
	(earnOnStablecoinEnabled ? "uk_earning_intro_screen_title" : "start_staking") | translate
}}</span>
@if (earnOnStablecoinEnabled) {
	<div class="content">
		<div class="section">
			<div class="details">
				<span class="title">{{ "uk_earning_intro_staking_crypto_title" | translate }}</span>
				<span class="description">{{ "uk_earning_intro_staking_crypto_subtitle" | translate }}</span>
			</div>
		</div>
		<div class="section">
			<div class="details">
				<span class="title">{{ "uk_earning_intro_earn_on_stablecoin_title" | translate }}</span>
				<span class="description">{{ "uk_earning_intro_earn_on_stablecoin_subtitle" | translate }}</span>
			</div>
		</div>
		<div class="section">
			<div class="details">
				<span class="title">{{
					(autoStakingEnabled ? "uk_earning_intro_auto_earning_title" : "uk_earn_intro_info_title_3")
						| translate
				}}</span>
				<span class="description">
					{{
						(autoStakingEnabled
							? "uk_earning_intro_auto_earning_subtitle"
							: "uk_earn_intro_info_subtitle_3"
						) | translate
					}}
				</span>
			</div>
		</div>
	</div>
} @else {
	@if(autoStakingEnabled) {
		<span class="subtitle">{{ "auto_staking_intro_subheader" | translate }}</span>
	}
	<div class="content">
		<div class="section">
			<img alt="Weekly Earnings" [src]="'/assets/images/staking/weekly_rewards.svg'" />
			<div class="details">
				<span class="title">{{ "weekly_rewards" | translate }}</span>
				<span class="description">{{ "uk_finprom_weekly_rewards_description" | translate }}</span>
			</div>
		</div>
		<div class="section">
			<img alt="Fully Flexible" [src]="'/assets/images/staking/fully_flexible.svg'" />
			<div class="details">
				<span class="title">{{
					(autoStakingEnabled ? "auto-staking-tooltip-title" : "fully_flexible") | translate
				}}</span>
				<span class="description">{{
					(autoStakingEnabled ? "auto_staking_intro_description" : "uk_finprom_fully_flexible_description") | translate
				}}</span>
			</div>
		</div>
		<div class="section">
			<img alt="Set it, forget it" [src]="'/assets/images/staking/set_it_forget_it.svg'" />
			<div class="details">
				<span class="title">{{ "set_it_forget_it" | translate }}</span>
				<span class="description">
					{{ "uk_finprom_set_it_forget_it_description" | translate }}
				</span>
			</div>
		</div>
	</div>
}
